var router = require('./router.js');

$(document).ready(function(){
    $.ajax({
        url: 'js/data/data.json',
        cache: false,
        dataType: "json"
    }).done(function(data) {
        router.init(data);
        if(!window.location.hash) {
            routie('/es')
        }
    });



})